import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ElectricalInspectionForm from './components/ElectricalInspectionForm';

const EditElectricalInspectionPage: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    return (
        <div className="animate-in fade-in duration-500">
            <ElectricalInspectionForm 
                id={id ? parseInt(id) : undefined}
                onBack={() => navigate('/assets?tab=electrical')}
                onSaveSuccess={() => navigate('/assets?tab=electrical')}
            />
        </div>
    );
};

export default EditElectricalInspectionPage;
